import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { ExamGradedResponse, ExamResponse } from "./type";

const BASE_URL = process.env.REACT_APP_BASE_URL ?? "http://localhost:8000";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}/` }),
  endpoints: (builder) => ({
    getIsUserIdExist: builder.mutation<boolean, string>({
      query: (userId) => `users/${userId}`,
    }),
    generateUserId: builder.mutation<string, void>({
      query: () => ({
        url: "users",
        method: "POST",
      }),
    }),
    updateExamResponse: builder.mutation<
      ExamResponse,
      ExamResponse & { user_id: string }
    >({
      query: ({ user_id, ...body }) => ({
        url: "exams/responses",
        params: { user_id },
        method: "PUT",
        body: body,
      }),
    }),
    getExamResponse: builder.query<ExamResponse, string>({
      query: (userId) => `exams/responses/${userId}`,
    }),
    getCompareResponse: builder.query<ExamGradedResponse, string>({
      query: (userId) => `exams/compare-responses/${userId}`,
    }),
    getExamNumQuestions: builder.query<number, string>({
      query: () => "exams/num-questions",
    }),
    getExamExtraNumQuestions: builder.query<number, string>({
      query: () => "exams/num-extra-questions",
    }),
    getExamNumAnswers: builder.query<number, string>({
      query: () => "exams/num-answers",
    }),
    getExamNumTemplates: builder.query<number, number>({
      query: () => "exams/num-templates",
    }),
  }),
});

export const {
  useGetIsUserIdExistMutation,
  useGenerateUserIdMutation,
  useUpdateExamResponseMutation,
  useGetExamResponseQuery,
  useGetCompareResponseQuery,
  useGetExamNumQuestionsQuery,
  useGetExamExtraNumQuestionsQuery,
  useGetExamNumAnswersQuery,
  useGetExamNumTemplatesQuery,
} = api;
